import styles from './stage-view.module.css';
import {
  StageEngagementFragment,
  useOnStageEngagementSubmissionsChangedSubscription,
  useStageGetSubmissionQuery,
} from '@/generated/graphql';
import { useMemo } from 'react';
import { StageReactions } from '@/components/StageReactions/StageReactions';
import { useScreenTheme } from '@/providers/ScreenThemeStateProvider/EventScreenThemeContext';
import { useReportFreeformSlide } from '../stageFreeformPresentationContext.ts';
import {
  StageSlideCanvas,
  type StageSlideCanvasStyles,
} from './stageSlideCanvas.ts';

export const StageSlidesEngagement = ({
  engagement,
}: {
  engagement: StageEngagementFragment;
}) => {
  const currentSlideId = useMemo(() => {
    if (engagement.viewData.__typename === 'SlidesViewData') {
      return engagement.viewData.currentSlide;
    }
    return null;
  }, [engagement.viewData]);

  const { data, refetch /* , loading, error  */ } = useStageGetSubmissionQuery({
    skip: !currentSlideId,
    variables: { id: currentSlideId! },
  });

  useOnStageEngagementSubmissionsChangedSubscription({
    variables: { engagementId: engagement.id },
    onData: () => {
      refetch();
    },
  });

  const slideData =
    data?.submission?.data?.__typename === 'SlidesSubmissionData'
      ? data.submission.data
      : null;

  const { state } = useScreenTheme();
  useReportFreeformSlide(slideData);

  return (
    <StageSlideCanvas
      currentSlideId={currentSlideId}
      slideData={slideData}
      styles={styles as StageSlideCanvasStyles}
      themeFonts={{
        headingFontFamily: state.savedTheme.headingFontFamily,
        bodyFontFamily: state.savedTheme.bodyFontFamily,
      }}
    >
      {currentSlideId && <StageReactions submissionId={currentSlideId} />}
    </StageSlideCanvas>
  );
};
